import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { MediaType } from "@front/m19-api-client";
import { AccountSelectionService, BrandAssetsService } from "@front/m19-services";
import { IIconComponent } from "@front/m19-ui";
import { switchMap } from "rxjs";

@Component({
  selector: "app-video-preview",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IIconComponent],
  host: {
    class: "bg-muted flex h-31.25 w-44.75 shrink-0 items-center justify-center overflow-hidden rounded-xl p-2",
  },
  template: `
    @if (effectiveVideoAssetUrl()) {
      <video
        class="size-full rounded-lg object-contain"
        autoplay
        [muted]="'muted'"
        loop
        [src]="effectiveVideoAssetUrl()"
      ></video>
    } @else {
      <IIcon name="play" class="text-muted-foreground size-5" />
    }
  `,
})
export class VideoPreviewComponent {
  readonly brandAssetsService = inject(BrandAssetsService);
  readonly accountSelectionService = inject(AccountSelectionService);

  readonly videoUrl = input<string>();

  private readonly brandAssets = toSignal(
    this.accountSelectionService.singleAccountMarketplaceSelection$.pipe(
      switchMap((am) => this.brandAssetsService.getBrandAssetsById(am.accountId, am.marketplace)),
    ),
  );

  private readonly videoAssetUrl = computed(() => {
    return this.brandAssets()
      ?.get(this.videoUrl() ?? "")
      ?.find((ba) => ba.mediaType === MediaType.videoAsset)?.url;
  });

  readonly effectiveVideoAssetUrl = computed(() => {
    return this.videoAssetUrl() ?? this.videoUrl();
  });
}
